import Vue from 'vue';

import Button from '@components/ui/button.vue';

let PageComponent = {
  name: 'payment',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    't-button': Button,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let payment = document.querySelector('#payment');
    if (payment) {
      payment.remove();
    }

    let url = '/api/templates/info/payment';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/info/payment/index.js